/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthTenantsRouteImport } from './routes/_auth.tenants'
import { Route as AuthSystemRouteImport } from './routes/_auth.system'
import { Route as AuthRegionsRouteImport } from './routes/_auth.regions'
import { Route as AuthPartnersRouteImport } from './routes/_auth.partners'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthAccountRouteImport } from './routes/_auth.account'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth.settings.index'
import { Route as AuthTenantTenantIdRouteImport } from './routes/_auth.tenant.$tenantId'
import { Route as AuthSettingsLlmProvidersRouteImport } from './routes/_auth.settings.llm-providers'
import { Route as AuthSettingsAuditLogRouteImport } from './routes/_auth.settings.audit-log'
import { Route as AuthSettingsApiTesterRouteImport } from './routes/_auth.settings.api-tester'
import { Route as AuthSettingsAdminsRouteImport } from './routes/_auth.settings.admins'
import { Route as AuthPartnerPartnerIdRouteImport } from './routes/_auth.partner.$partnerId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTenantsRoute = AuthTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSystemRoute = AuthSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegionsRoute = AuthRegionsRouteImport.update({
  id: '/regions',
  path: '/regions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPartnersRoute = AuthPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTenantTenantIdRoute = AuthTenantTenantIdRouteImport.update({
  id: '/tenant/$tenantId',
  path: '/tenant/$tenantId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsLlmProvidersRoute =
  AuthSettingsLlmProvidersRouteImport.update({
    id: '/settings/llm-providers',
    path: '/settings/llm-providers',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsAuditLogRoute = AuthSettingsAuditLogRouteImport.update({
  id: '/settings/audit-log',
  path: '/settings/audit-log',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsApiTesterRoute = AuthSettingsApiTesterRouteImport.update({
  id: '/settings/api-tester',
  path: '/settings/api-tester',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsAdminsRoute = AuthSettingsAdminsRouteImport.update({
  id: '/settings/admins',
  path: '/settings/admins',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPartnerPartnerIdRoute = AuthPartnerPartnerIdRouteImport.update({
  id: '/partner/$partnerId',
  path: '/partner/$partnerId',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthAccountRoute
  '/dashboard': typeof AuthDashboardRoute
  '/partners': typeof AuthPartnersRoute
  '/regions': typeof AuthRegionsRoute
  '/system': typeof AuthSystemRoute
  '/tenants': typeof AuthTenantsRoute
  '/partner/$partnerId': typeof AuthPartnerPartnerIdRoute
  '/settings/admins': typeof AuthSettingsAdminsRoute
  '/settings/api-tester': typeof AuthSettingsApiTesterRoute
  '/settings/audit-log': typeof AuthSettingsAuditLogRoute
  '/settings/llm-providers': typeof AuthSettingsLlmProvidersRoute
  '/tenant/$tenantId': typeof AuthTenantTenantIdRoute
  '/settings/': typeof AuthSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthAccountRoute
  '/dashboard': typeof AuthDashboardRoute
  '/partners': typeof AuthPartnersRoute
  '/regions': typeof AuthRegionsRoute
  '/system': typeof AuthSystemRoute
  '/tenants': typeof AuthTenantsRoute
  '/partner/$partnerId': typeof AuthPartnerPartnerIdRoute
  '/settings/admins': typeof AuthSettingsAdminsRoute
  '/settings/api-tester': typeof AuthSettingsApiTesterRoute
  '/settings/audit-log': typeof AuthSettingsAuditLogRoute
  '/settings/llm-providers': typeof AuthSettingsLlmProvidersRoute
  '/tenant/$tenantId': typeof AuthTenantTenantIdRoute
  '/settings': typeof AuthSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/account': typeof AuthAccountRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/partners': typeof AuthPartnersRoute
  '/_auth/regions': typeof AuthRegionsRoute
  '/_auth/system': typeof AuthSystemRoute
  '/_auth/tenants': typeof AuthTenantsRoute
  '/_auth/partner/$partnerId': typeof AuthPartnerPartnerIdRoute
  '/_auth/settings/admins': typeof AuthSettingsAdminsRoute
  '/_auth/settings/api-tester': typeof AuthSettingsApiTesterRoute
  '/_auth/settings/audit-log': typeof AuthSettingsAuditLogRoute
  '/_auth/settings/llm-providers': typeof AuthSettingsLlmProvidersRoute
  '/_auth/tenant/$tenantId': typeof AuthTenantTenantIdRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account'
    | '/dashboard'
    | '/partners'
    | '/regions'
    | '/system'
    | '/tenants'
    | '/partner/$partnerId'
    | '/settings/admins'
    | '/settings/api-tester'
    | '/settings/audit-log'
    | '/settings/llm-providers'
    | '/tenant/$tenantId'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/account'
    | '/dashboard'
    | '/partners'
    | '/regions'
    | '/system'
    | '/tenants'
    | '/partner/$partnerId'
    | '/settings/admins'
    | '/settings/api-tester'
    | '/settings/audit-log'
    | '/settings/llm-providers'
    | '/tenant/$tenantId'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/account'
    | '/_auth/dashboard'
    | '/_auth/partners'
    | '/_auth/regions'
    | '/_auth/system'
    | '/_auth/tenants'
    | '/_auth/partner/$partnerId'
    | '/_auth/settings/admins'
    | '/_auth/settings/api-tester'
    | '/_auth/settings/audit-log'
    | '/_auth/settings/llm-providers'
    | '/_auth/tenant/$tenantId'
    | '/_auth/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/tenants': {
      id: '/_auth/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof AuthTenantsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/system': {
      id: '/_auth/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AuthSystemRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/regions': {
      id: '/_auth/regions'
      path: '/regions'
      fullPath: '/regions'
      preLoaderRoute: typeof AuthRegionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/partners': {
      id: '/_auth/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof AuthPartnersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account': {
      id: '/_auth/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tenant/$tenantId': {
      id: '/_auth/tenant/$tenantId'
      path: '/tenant/$tenantId'
      fullPath: '/tenant/$tenantId'
      preLoaderRoute: typeof AuthTenantTenantIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/llm-providers': {
      id: '/_auth/settings/llm-providers'
      path: '/settings/llm-providers'
      fullPath: '/settings/llm-providers'
      preLoaderRoute: typeof AuthSettingsLlmProvidersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/audit-log': {
      id: '/_auth/settings/audit-log'
      path: '/settings/audit-log'
      fullPath: '/settings/audit-log'
      preLoaderRoute: typeof AuthSettingsAuditLogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/api-tester': {
      id: '/_auth/settings/api-tester'
      path: '/settings/api-tester'
      fullPath: '/settings/api-tester'
      preLoaderRoute: typeof AuthSettingsApiTesterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/admins': {
      id: '/_auth/settings/admins'
      path: '/settings/admins'
      fullPath: '/settings/admins'
      preLoaderRoute: typeof AuthSettingsAdminsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/partner/$partnerId': {
      id: '/_auth/partner/$partnerId'
      path: '/partner/$partnerId'
      fullPath: '/partner/$partnerId'
      preLoaderRoute: typeof AuthPartnerPartnerIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAccountRoute: typeof AuthAccountRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthPartnersRoute: typeof AuthPartnersRoute
  AuthRegionsRoute: typeof AuthRegionsRoute
  AuthSystemRoute: typeof AuthSystemRoute
  AuthTenantsRoute: typeof AuthTenantsRoute
  AuthPartnerPartnerIdRoute: typeof AuthPartnerPartnerIdRoute
  AuthSettingsAdminsRoute: typeof AuthSettingsAdminsRoute
  AuthSettingsApiTesterRoute: typeof AuthSettingsApiTesterRoute
  AuthSettingsAuditLogRoute: typeof AuthSettingsAuditLogRoute
  AuthSettingsLlmProvidersRoute: typeof AuthSettingsLlmProvidersRoute
  AuthTenantTenantIdRoute: typeof AuthTenantTenantIdRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccountRoute: AuthAccountRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthPartnersRoute: AuthPartnersRoute,
  AuthRegionsRoute: AuthRegionsRoute,
  AuthSystemRoute: AuthSystemRoute,
  AuthTenantsRoute: AuthTenantsRoute,
  AuthPartnerPartnerIdRoute: AuthPartnerPartnerIdRoute,
  AuthSettingsAdminsRoute: AuthSettingsAdminsRoute,
  AuthSettingsApiTesterRoute: AuthSettingsApiTesterRoute,
  AuthSettingsAuditLogRoute: AuthSettingsAuditLogRoute,
  AuthSettingsLlmProvidersRoute: AuthSettingsLlmProvidersRoute,
  AuthTenantTenantIdRoute: AuthTenantTenantIdRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
